module.exports = __webpack_public_path__ + "img/EKWATEUR.9dc54b54.png";